const state = {
    me:'',
}
const mutations = {
    setMe(state, model) {
        state.me = model
    },
}
const actions = {

}
export default {
    namespaced: true,
    state,
    mutations,
    actions,
};